import { generateGoogleEvent } from './GCalendarUtils';
import { GOOGLE_CLASSROOM_SCOPES, GOOGLE_USERINFO_SCOPES } from '../../const';
import axios from 'axios';
import {
  API_CLASSROOM_GOOGLE_CONNECT,
  API_CLASSROOM_GOOGLE_CONNECTION,
  API_CLASSROOM_GOOGLE_IS_CONNECTED,
  API_CLASSROOM_GOOGLE_MEET
} from '../../services/api/apiConst';

/// Request to backend to connect with google
/// This is going to open a new window with google login
/// and ask for permissions and save the connection in backend
export async function requestPermissions(scope, callback, callbackError) {
  const response = await axios.post(API_CLASSROOM_GOOGLE_CONNECT);
  const res = window.open(response.data.url, '_blank', {
    width: 500,
    height: 600,
    menubar: 'no',
    toolbar: 'no'
  });

  const interval = setInterval(() => {
    if (res.closed) {
      clearInterval(interval);
      if (arePermissionsGranted(scope) && callback) {
        callback();
      } else if (callbackError) {
        callbackError();
      }
    }
  }, 1000);
}

/// Request to backend to check if the user has granted permissions
/// for the given scope
export async function arePermissionsGranted(scope) {
  try {
    const res = await axios.post(API_CLASSROOM_GOOGLE_IS_CONNECTED, { scope });
    return res.data;
  } catch (err) {
    return false;
  }
}

/// Request to backend to check if the user has granted permissions
export async function isGoogleConnected() {
  try {
    const res = await axios.post(API_CLASSROOM_GOOGLE_IS_CONNECTED, { scope: GOOGLE_USERINFO_SCOPES });
    return res.data;
  } catch (err) {
    return false;
  }
}

/// Request to backend to create a google meet
export async function createGoogleMeet(classroomName) {
  const googleEvent = generateGoogleEvent(classroomName);
  const res = await axios.post(API_CLASSROOM_GOOGLE_MEET, googleEvent);
  return res.data;
}

/// Request to backend to revoke google connection
export async function revokeGoogleConnection() {
  const res = await axios.delete(API_CLASSROOM_GOOGLE_CONNECTION);
  return res.data;
}
